var OCS = OCS || {};
OCS.Classes = OCS.Classes || {};
OCS.Settings = OCS.Settings || {};
OCS.Classes.SiteSelection = new Class({
    Implements: [Events, Options],
    options: {
        id: null,
        id_name: 'stid', // A name such as stid, stid2, or id you want stored in the cookie
        html_attribute_id_name: 'stid', // Attribute to look at for the id when changing ids. 
        html_name_attribute: 'text', // Attribute used to pull the text for the title of the tooltip.
        html_name_alt_attribute: 'toolTipTitle', // An alternate atrribute used to pull the text for the title of the tooltip.
        changed_event_name: "changed", // Event that is fired when the id value is changed
        change_id_content_url: "/index.php/site/site_select/", // Url to pull for the site select content
        change_id_button_selector: "#site_button_home", // Button to listen for when to display the site select content
        change_id_content_title: "Select Mesonet Station", // Title to use for the site select content
        mouseover_event: "mouseover",
        mouseenter_event: "mouseenter",
        mouseleave_event: "mouseleave",
        mouseout_event: "mouseout",
        popup_closed_event: 'popup_closed',
        popup_opened_event: 'popup_opened',
        popup_template: '<div class="{{popup_wrapper_class}}"><div class="{{popup_container_class}}"><div class="{{popup_content_class}}">{{#popup_close_container_top}}{{{popup_close_content}}}{{/popup_close_container_top}}{{{popup_content}}}{{#popup_close_container_bottom}}{{{popup_close_content}}}{{/popup_close_container_bottom}}</div></div></div>',
        popup_template_close: '<div class="{{popup_close_container_class}}"><div class="{{popup_close_button_class}}">Press "esc" OR click outside of box to close</div></div>',
        id_search_url: "/index.php/site/site_select_results/",
        search_form_selector: "#site_select_form", // Form selector for the auto search fields
        zip_input_selector: "#zip", // Input to look at for the value to send for a zip code to search by
        search_changed_timeout: 500,
        search_result_element_selector: "#site_results", // Html element to store the site search results
        id_name_link_selector: ".stid_link", // Html selector to look for and listen on being clicked to change the id
        tip_className: "siteselection-tooltip", // Class name to apply to the base of the tooltip.
        tip_html_id: "site_select_tooltip", // Id to apply to the base fo the tooltip, necessary for WAI-ARIA support.
        tip_text_attribute_name: "alt", // Attribute to look at for the text content of the tooltip
        site_tip_meta_info_selector: "#Current_obs_map area",
        use_cookie: true, // Whether or not to use a cookie
        update_cookie_on_change: true, // Whether or not to update the cookie with a site change
        cookie_duration: 30, // Duration in days for the cookie to exist
        windows_safe: false             // Patch so that IE and Edge will properly listen for mouse events
    },
    popup: null,
    search_timeout: null,
    search_req: null,
    content_req: null,
    cookie: null,
    tips: null,
    bound_methods: {},
    initialize: function (options) {
        this.setOptions(options);
        this.bound_methods.on_mouse_over = this.on_mouse_over_safe.bind(this);
        this.bound_methods.on_mouse_out = this.on_mouse_out_safe.bind(this);
        this.bound_methods.on_popup_closed = this.on_popup_closed.bind(this);
        this.bound_methods.on_popup_opened = this.on_popup_opened.bind(this);
        this.bound_methods.on_search_changed = this.on_search_changed.bind(this);
        this.bound_methods.on_id_name_link_click = this.on_id_name_link_click.bind(this);
        if (this.options.use_cookie) {
            this.cookie = new Cookie(this.options.id_name, {"duration": this.options.cookie_duration, "domain": this.get_cookie_domain()});
        }
        this.get_id();
        if (this.options.change_id_content_url) {
            this.content_req = new Request({
                onSuccess: this.on_change_content_success.bind(this),
                url: this.options.change_id_content_url
            }).send();
        }
        if (this.options.id_search_url) {
            this.search_req = new Request({
                onSuccess: this.on_search_success.bind(this),
                url: this.options.id_search_url,
                link: 'cancel' // Cancel an existing request and run with the new request data
            });
        }

        this.apply_button_listner();


    },

    /*
     * 
     * Actions
     * 
     */
    find_id: function (searchTerms) {
        this.search_req.send(searchTerms);
    },

    apply_button_listner: function () {
        $$(this.options.change_id_button_selector).each(function (el) {
            this.popup = new OCS.Classes.MooPopup(el, {
                any_click_cancels: true,
                popup_template: this.options.popup_template,
                popup_template_close: this.options.popup_template_close
            });
            this.popup.addEvent(this.popup.options.active_event_name, this.bound_methods.on_popup_opened);
            this.popup.addEvent("close", this.bound_methods.on_popup_closed);
        }, this);
    },

    apply_link_listener: function () {
        document.id(document.body).getElements(this.options.id_name_link_selector).each(function (el) {
            el.removeEvents('click');
            el.addEvent('click', this.bound_methods.on_id_name_link_click);
        }.bind(this));
    },

    /*
     * 
     * Event listeners
     * 
     */
    on_id_name_link_click: function (e) {
        e.stop();
        var id = String.from(e.target.get(this.options.html_attribute_id_name)).toLowerCase();
        var name = e.target.get(this.options.html_name_attribute);
        if (!name) {
            name = e.target.get(this.options.html_name_alt_attribute);
        }
        this.set_id({id: id, name: name});
    },
    on_mouse_over_safe: function (event) {
        event.target.fireEvent(this.options.mouseenter_event, event);
    },
    on_mouse_out_safe: function (event) {
        event.target.fireEvent(this.options.mouseleave_event, event);
    },
    on_popup_closed: function (popup) {
        this.destroy_tips();
        if (this.search_req.running) {
            this.search_req.cancel();
        }
        this.fireEvent(this.options.popup_closed_event, {context: this, popup: popup});
    },
    on_popup_opened: function (popup) {
        if (popup && popup.container) {
            this.fireEvent(this.options.popup_opened_event, {context: this, popup: popup});
            popup.container.getElements(this.options.search_form_selector).each(function (item) {
                document.id(item).removeEvents('keyup');
                document.id(item).removeEvents('change');
                document.id(item).removeEvents('submit');
                document.id(item).addEvent('keyup', this.bound_methods.on_search_changed);
                document.id(item).addEvent('change', this.bound_methods.on_search_changed);
                document.id(item).addEvent('submit', this.bound_methods.on_search_changed);
                item.focus();
            }.bind(this));
            this.find_id();
            var elements = $$(this.options.site_tip_meta_info_selector);
            if (this.options.windows_safe) {
                elements.addEvent(this.options.mouseover_event, this.bound_methods.on_mouse_over);
                elements.addEvent(this.options.mouseout_event, this.bound_methods.on_mouse_out);
            }

            this.tips = new Tips(elements, {
                onShow: this.on_tip_show.bind(this),
                text: this.get_tip_text.bind(this),
                className: this.options.tip_className,
                title: "toolTipTitle",
                id: this.options.tip_html_id
            });
            this.apply_link_listener();
        }
    },
    on_tip_show: function (tip, el) {
        tip.setStyles({
            visibility: 'hidden',
            display: 'block'
        }).fade('in');
    },
    on_search_changed: function (e) {
        if (this.search_timeout) {
            clearTimeout(this.search_timeout);
            this.search_timeout = null;
        }
        if (e.key === "enter" || e.key === "return") {
            this.find_id(this.get_search_terms());
        } else {
            this.search_timeout = setTimeout(function () {
                this.find_id(this.get_search_terms());
                this.search_timeout = null;
            }.bind(this), this.options.search_changed_timeout);
        }
    },
    on_change_content_success: function (template_content) {
        var tm = new OCS.Classes.TemplateManager();
        tm.define_template('site_select', template_content);
        if (this.popup) {
            var html_content = tm.get_html('site_select', {"site_select_title": this.options.change_id_content_title});
            if (this.popup.container) {
                // This means the popup is open
                this.popup.process_form(html_content);
            } else {
                this.popup.set_popup_content(html_content);
            }


        }

    },
    on_search_success: function (text) {
        if (this.popup && this.popup.container) {
            var els = this.popup.container.getElements(this.options.search_result_element_selector);
            els.each(function (element) {
                element.empty();
                element.appendHTML(text);
            });
            this.apply_link_listener();
        }

    },

    /*
     * Event Fires
     */
    id_changed: function (new_val, old_val) {
        if (this.popup) {
            this.popup.close_form();
        }
        this.fireEvent(this.options.changed_event_name, {'new': new_val, 'old': old_val, context: this});
    },

    /*
     * 
     * Set / Get Methods
     * 
     */
    set_id: function (val) {
        var old = this.options.id;
        this.options.id = val.id;
        if (this.options.use_cookie && this.options.update_cookie_on_change) {
            this.cookie.write(val.id);
        }
        this.id_changed(val, {id: old});
    },
    get_id: function () {
        if (!this.options.id && this.options.use_cookie) {
            var id = this.cookie.read();
            if (id) {
                this.options.id = id;
            }
        }
        return this.options.id;
    },
    get_search_terms: function () {
        return "zip=" + $$(this.options.zip_input_selector).get('value');
    },
    get_tip_text: function (element) {
        return element.get(this.options.tip_text_attribute_name);
    },    
    get_cookie_domain: function () {
        var domain = window.location.host;
        /* istanbul ignore if */
        if (OCS.Settings && OCS.Settings.cookie_domain) {
            return OCS.Settings.cookie_domain;
        } else {
            var url = domain;
            var matches = url.match(/([a-zA-Z0-9\-]+\.)?([a-zA-Z0-9\-]+)\.(org|us|gov|edu|local)/i);
            /* istanbul ignore if */
            if (matches && matches.length === 4) {
                if (matches[3] === 'org' || matches[3] === 'us' || matches[3] === 'local') {
                    domain = matches[2] + '.' + matches[3];
                } else if (matches[3] === 'gov' || matches[3] === 'edu') {
                    domain = matches[1] + matches[2] + '.' + matches[3];
                }
            }
        }
        return domain;
    },
    destroy_tips: function () {
        if (this.tips) {
            var elements = $$(this.options.site_tip_meta_info_selector);
            if (this.options.windows_safe) {
                elements.removeEvent(this.options.mouseover_event, this.bound_methods.on_mouse_over);
                elements.removeEvent(this.options.mouseout_event, this.bound_methods.on_mouse_out);
            }
            this.tips.detach(elements);
            clearTimeout(this.tips.timer);
            if (this.tips.container) {
                this.tips.container.destroy();
            }
            /* istanbul ignore if */
            if (this.tips.tip) {
                this.tips.tip.destroy();
            }
            this.tips.removeEvents();
            this.tips = null;
        }
    },
    destroy: function () {
        this.destroy_tips();
        this.search_req.cancel();
        this.search_req.removeEvents();
        this.search_req = null;
        /* istanbul ignore if */
        if (this.search_timeout) {
            clearTimeout(this.search_timeout);
            this.search_timeout = null;
        }
        if (this.popup) {
            this.popup.removeEvents();
            this.popup = null;
        }
        this.removeEvents();
    }
});